export default __webpack_public_path__ + "static/media/ic_cooperation.d903fcde9de40426865f8c465168fc41.svg";